import { useContext } from 'react'

import { KpiStorageContext } from '@provider/Kpi/StorageProvider'

import type { IKpiStorageContext } from '@base/@types/providers/Kpi/StorageProvider'

export default function useKpiStorage(): IKpiStorageContext {
  const context = useContext(KpiStorageContext)

  return context
}
